import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { headers } from '../../styles/type';

const Th = styled.th`
  ${headers.eyebrow}
  background: ${colors.white};
  border-bottom: solid 1px ${colors.gray['200']};
  padding: ${rem(16)};
  text-align: center;
  vertical-align: top;
  color: ${colors.blue['800']};

  table & {
    p {
      color: inherit;
    }
  }
`;

const TableHeaderCell = ({ children }) => (
  <Th>
    {children}
  </Th>
);

TableHeaderCell.propTypes = {
  children: PropTypes.node.isRequired
};

export default TableHeaderCell;
